import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const Badge = styled.span<IBadgeProps>`
  padding: ${({ size }) => (size ? 0.3 * size : 0.3)}em ${({ size }) =>
  size ? 0.8 * size : 0.8}em;
  font-size: ${({ size }) => (size ? 0.8 * size : 0.8)}em;
  font-weight: 600;
  
  &#badge#badge#badge#badge#badge {
    color: #fff !important;
  } 
  
  border-radius: 3px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};

  ${is('primary')`
    color: #fff !important;
    background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  `}
  ${is('warning')`
    color: #fff;
    background-color: ${({ theme }: ITheme) => theme.colors.palette.tangerine};
  `}
  ${is('error')`
    color: #fff;
    background-color: ${({ theme }: ITheme) => theme.colors.palette.reddish};
  `}

  ${is('extraSmall')`
    font-size: ${({ size }) => (size ? 0.7 * size : 0.7)}em;
  `}
`

export default Badge

export interface IBadgeProps {
  primary?: boolean
  warning?: boolean
  error?: boolean
  size?: number
  extraSmall?: boolean
}
